import React from 'react';
import { AnnouncementBar } from './AnnouncementBar';
import { Header } from './Header';
import { Footer } from './Footer';
type SiteLayoutProps = {
  children: React.ReactNode;
};
export function SiteLayout({
  children
}: SiteLayoutProps) {
  return <div className="min-h-screen w-full bg-sand-50" data-id="element-569" data-mp="jgwokf2yrgr6">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[120] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-[15px] focus:font-semibold focus:text-ink" data-id="element-570" data-mp="eibp4hvjd13s">
        Skip to content
      </a>
      <AnnouncementBar data-id="element-571" data-mp="ik622q5wuix" />
      <Header data-id="element-572" data-mp="j3rhtf0u11p" />
      <main id="main" data-id="element-573" data-mp="jlsf3cmp3fy">{children}</main>
      <Footer data-id="element-574" data-mp="kn7diwrma2y" />
    </div>;
}